<script>
export default {
  props: ['item'],
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  }
}
</script>

<template>
  <div>

    <div class="row set-sm-375">
      <div class="col-lg-4">
        <div class="card-box">
          <!-- <h5 class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> About :</h5> -->

          <div class="">
            <div class="mb-4">
              <label for="">Status :</label>
              <div class="alert small m-0 text-white" :class="'bg-'+(item.status == 0 ? 'danger' : item.status == 1 ? 'purple' : item.status == 2 ? 'warning' : item.status == 3 ? 'blue' : item.status == 4 ? 'success' : 'dark')">{{ (item.status == 0 ? 'Trash' : item.status == 1 ? 'Draft' : item.status == 2 ? 'Active' : item.status == 3 ? 'Hold' : item.status == 4 ? 'Complete' : '') }}</div>
            </div>
            <div class="mb-4">
              <label for="">Priority :</label>
              <div class="alert small m-0" :class="'alert-'+(item.priority == 1 ? 'teal' : item.priority == 2 ? 'light' : item.priority == 3 ? 'danger' : 'dark')">{{ (item.priority == 1 ? 'Low' : item.priority == 2 ? 'Normal' : item.priority == 3 ? 'High' : '') }}</div>
            </div>
            <div class="mb-4">
              <label for="">Created by :</label>
              <div v-if="item.user" class="mb-2 card-box border position-relative p-1 _box-shadow-0-1-4-b-2">
                <div class="row m-0">
                  <div class="_w-50 mr-2">
                    <img v-if="item.user.avatar" :src="formatImage(item.user.avatar)" class="_w-50 rounded">
                    <avatar v-else :username="item.user.name" :size="50" :rounded="false" class="rounded"></avatar>
                  </div>
                  <div class="col p-0 small">
                    <h6 class="mb-0">{{item.user.name}}</h6>
                    <div class="text-muted small _lh-16">{{item.user.email}}</div>
                    <div class="text-muted small _lh-16">{{formatPhone(item.user.phone)}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-4">
              <label for="">Assigned to :</label>
              <div v-for="(assign, assign_i) in item.assigned_to" :key="assign_i" class="mb-2 card-box border position-relative p-1 _box-shadow-0-1-4-b-2">
                <div class="row m-0">
                  <div class="_w-50 mr-2">
                    <img v-if="assign.avatar" :src="formatImage(assign.avatar)" class="_w-50 rounded">
                    <avatar v-else :username="assign.name" :size="50" :rounded="false" class="rounded"></avatar>
                  </div>
                  <div class="col p-0 small">
                    <h6 class="mb-0">{{assign.name}}</h6>
                    <div class="text-muted small _lh-16">{{assign.email}}</div>
                    <div class="text-muted small _lh-16">{{formatPhone(assign.phone)}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-4">
              <label for="">Project Folders :</label>
              <div v-for="(proj, proj_i) in item.project_folders" :key="proj_i" class="mb-2 card-box border position-relative p-1 _box-shadow-0-1-4-b-2 small">
                <Icon icon="ri:folder-open-fill" :class="proj.status == 1 ? 'text-lighten-success' : 'text-lighten-danger'"></icon> <small>{{proj.title}}</small>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-sm table-px-0">
                <tbody>
                  <tr><th class="text-nowrap border-0"><label>Created date :</label></th><td class="border-0 small">{{ item.created_at ? moment(item.created_at).format('MM-DD-YYYY') : '' }}</td></tr>
                  <tr><th class="text-nowrap"><label>Start date :</label></th><td class="small">{{ item.start_date ? moment(item.start_date).format('MM-DD-YYYY') : '' }}</td></tr>
                  <tr><th class="text-nowrap"><label>Due date :</label></th><td class="small">{{ item.due_date ? moment(item.due_date).format('MM-DD-YYYY') : '' }}</td></tr>
                  <tr><th class="text-nowrap"><label>Completed date :</label></th><td class="small">{{ item.completed_date ? moment(item.completed_date).format('MM-DD-YYYY') : '' }}</td></tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
      <div class="col-lg-8">
        <div class="card-box p-4">
          <h2 class="border-left border-primary _b-s-2 pl-3 mb-4">{{item.title}}</h2>
          <p class="mb-5">{{item.summary}}</p>
          <h6 class="mb-3">Estimated progress</h6>
          <div class="progress mb-2"><div class="progress-bar progress-bar-striped bg-success" style="width: 25%"></div></div>
          <div class="row small text-muted mb-5">
            <div class="col-6 small">
              Created: {{moment(item.created_at).format('MM-DD-YYYY')}}
            </div>
            <div class="col-6 small text-right">
              Due: {{moment(item.due_date).format('MM-DD-YYYY')}}
            </div>
          </div>
          <div v-html="item.content"></div>
        </div>

      </div>
    </div>



  </div>
</template>
